module.exports = __webpack_public_path__ + "static/media/ban-solid.b3667bc3.svg";